import { format } from 'date-fns';
const opts = {
  filterable: false,
  sortable: false
};
export default {
  id: 'vehicle.dtcAlerts.history',
  name: 'vehicle.dtcAlerts.history',
  displayName: 'DTC Alerts',
  valueType: 'string',
  objectType: 'vehicle.history',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const dtcs = obj?.data?.obdTracker?.data?.dtcs || {};
    return JSON.stringify(Object.entries(dtcs).map(([code, {
      desc,
      ecu,
      time
    }]) => ({
      code,
      desc,
      ecu,
      time: time ? format(parseInt(time), 'P p') : ''
    })));
  }
};